import classNames from "classnames";
import { get } from "lodash";
import { FC, useEffect, useMemo, useState } from "react";
import Button from "~/components/Button";
import Container from "~/components/Container";
import SectionTitle from "~/components/SectionTitle";
import styles from "./FeaturedProducts.module.scss";
import FeatureProductItem from "./FeatureProductItem";
import React from "react";
import useClient from "~/hooks/useClient";

interface FeaturedProductsProps {
  title?: string;
  data?: any;
  dataCollectionSsr?: any;
}

const FeaturedProducts: FC<FeaturedProductsProps> = ({
  title,
  data,
  dataCollectionSsr,
}) => {
  const isClient = useClient();
  const [selectedTab, setSelectedTab] = useState<string>("");

  const content = get(data, "content", "");

  const tabCategories = useMemo(() => {
    try {
      const regexCustomVar = new RegExp(
        "(?<=var tab-categories=).*?(?=}})",
        "g"
      );
      const options = content.match(regexCustomVar)?.[0];
      const result = JSON.parse(options);
      setSelectedTab(result[0]?.value);
      return result;
    } catch (error) {
      return [];
    }
  }, [content]);

  useEffect(() => {
    if (tabCategories?.length && !selectedTab) {
      setSelectedTab(tabCategories[0].value);
    }
  }, [tabCategories?.length, selectedTab]);

  if (!isClient) {
    return null;
  }

  return (
    <Container
      rootClassName={styles.featured_products_wrapper}
      className={styles.featured_products}
    >
      <SectionTitle
        text={title}
        action={
          <div className={styles.categories}>
            {tabCategories?.map((category: any) => (
              <Button
                key={category.value}
                variant="secondary"
                type={selectedTab === category.value ? "solid" : "outline"}
                onClick={() => setSelectedTab(category.value)}
                className={classNames(
                  "whitespace-nowrap",
                  styles.category_item,
                  {
                    [styles.selected]: selectedTab === category.value,
                  }
                )}
              >
                {category.label.toLowerCase()}
              </Button>
            ))}
          </div>
        }
      />
      <div className="relative">
        {(tabCategories?.length || dataCollectionSsr) &&
          tabCategories?.map((category: any) => {
            return (
              <React.Fragment key={category.value}>
                <FeatureProductItem
                  identifier={category.value}
                  activeTab={selectedTab}
                  dataCollectionSsr={dataCollectionSsr}
                />
              </React.Fragment>
            );
          })}
      </div>
    </Container>
  );
};

export default FeaturedProducts;
